import { FC } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Frame, Headline, Layout, Spinner, Stack } from '@servicetitan/design-system';
import { DocumentTitle } from '@servicetitan/document-title';
import { EHStore } from '../common/stores/eh.store';
import { EHModuleCard } from './components/eh-module-card/eh-module-card';
import { Header } from '../common/components/header/header';

export const MainModule: FC = observer(() => {
    const [{ contentModules, ehModulesLoading }] = useDependencies(EHStore);

    return (
        <Frame className="main-frame" header={<Header />}>
            <DocumentTitle title="Home" />
            <div className="h-100 w-100 of-y-scroll">
                <div className="container m-t-8">
                    <Headline className="m-b-3" size="medium">
                        Enterprise Hub Modules
                    </Headline>

                    {ehModulesLoading ? (
                        <Stack className="p-t-4" justifyContent="center">
                            <Spinner />
                        </Stack>
                    ) : (
                        <Layout type="2Col" justifyContent="left" className="align-items-stretch">
                            {contentModules.map(m => {
                                return (
                                    <Layout.Section key={m.id} className="flex-grow-0">
                                        <Link to={m.path}>
                                            <EHModuleCard data={m} />
                                        </Link>
                                    </Layout.Section>
                                );
                            })}
                        </Layout>
                    )}
                </div>
            </div>
        </Frame>
    );
});
